import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class TrackingApi {

    static postPageVisit(pageVisit) {
        return HTTP.post(config.trackingApi.page, pageVisit)
            .then(response => response.data)
    }

    static postEvent(postEvent) {
        return HTTP.post(config.trackingApi.event, postEvent)
            .then(response => response.data)
    }

}